"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryFetch = void 0;
const tslib_1 = require("tslib");
const queryFetch_utils_1 = require("./queryFetch.utils");
const queryFetch = (clientData, options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () { return (0, queryFetch_utils_1.queryFn)(clientData, options, options.servicesEndpoint); });
exports.queryFetch = queryFetch;
//# sourceMappingURL=queryFetch.js.map